export default __webpack_public_path__ + "static/media/dashboard.e0008e86.svg";